module.exports = __webpack_public_path__ + "static/media/ShapeRight.271f5083.svg";